module.exports = __webpack_public_path__ + "media/video5.fc213160.mp4";